import React, { useEffect, useState } from 'react';
import { formatCurrency, getDataWithJoin } from '../../../utils/SamuiUtils';
import { formatDate } from '../../../utils/DateUtils';
import Pagination from '../Footer/Pagination';

const ViewHistoryItem = ({ open, onClose, itemId }) => {

    const [data, setData] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPageDropdown, setItemsPerPageDropdown] = useState(10);

    const handleItemsPerPageChange = (e) => {
        setItemsPerPageDropdown(Number(e.target.value));
        setCurrentPage(1);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const pageSize = itemsPerPageDropdown;
    const sliceStart = (currentPage - 1) * pageSize;
    const paginatedRows = data.slice(sliceStart, sliceStart + pageSize);
    const startIndex = data.length === 0 ? 0 : sliceStart + 1;
    const endIndex = data.length === 0 ? 0 : Math.min(sliceStart + pageSize, data.length);

    useEffect(() => {
        if (!open || !itemId) {
            return;
        }
        setCurrentPage(1);
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps -- fetch uses open/itemId/dates from closure
    }, [open, itemId, startDate, endDate]);

    useEffect(() => {
        if (!open) return undefined;
        const previous = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = previous;
        };
    }, [open]);

    const fetchData = async () => {
        let whereClause = `WHERE PD.Item_Id = ${itemId}`;
        if (startDate) {
            whereClause += ` AND PH.Pay_Date >= '${startDate}'`;
        }
        if (endDate) {
            whereClause += ` AND PH.Pay_Date <= '${endDate}'`;
        }
        whereClause += " ORDER BY PH.Pay_Date DESC, PH.Pay_No DESC";
        const response = await getDataWithJoin(
            `
                PH.Pay_Date, 
                PH.Pay_No, 
                PH.AP_Name, 
                PD.Item_Name, 
                PD.Item_Qty, 
                PD.Item_Unit, 
                PD.Item_Price_Unit,
                PD.Item_Discount, 
                PD.Item_DisType,
                PD.Item_Total 
            `,
            "API_0401_PAY_H PH",
            "LEFT JOIN API_0402_PAY_D PD ON PD.Pay_Id = PH.Pay_Id",
            whereClause
        );

        if (response && response.length > 0) {
            setData(response);
        } else {
            setData([]);
        }
    };

    if (!open) return null;

    return (
        <>
            <div
                className="modal-backdrop show"
                style={{ zIndex: 1040 }}
                aria-hidden="true"
                onClick={onClose}
            />
            <div
                className="modal show d-block"
                tabIndex="-1"
                role="dialog"
                aria-modal="true"
                style={{ zIndex: 1055 }}
            >
                <div
                    className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
                    role="document"
                    style={{ maxWidth: 'min(1140px, 96vw)', margin: '1.75rem auto' }}
                >
                    <div className="modal-content">
                    <div className="modal-header" style={{ backgroundColor: '#EF6C00', color: '#fff' }}>
                        <h5 className="modal-title text-white">ประวัติการซื้อสินค้า</h5>
                        <button type="button" className="btn-close btn-close-white" aria-label="Close" onClick={onClose} />
                    </div>
                    <div className="modal-body">
                        <div className="row g-3 mb-3">
                            <div className="col-md-3">
                                <label className="form-label">วันที่</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={startDate}
                                    onChange={e => setStartDate(e.target.value)}
                                />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">ถึงวันที่</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={endDate}
                                    onChange={e => setEndDate(e.target.value)}
                                />
                            </div>
                            <div className="col-md-12 d-flex justify-content-end">
                                <button
                                    type="button"
                                    className="btn btn-lg btn-danger"
                                    onClick={() => {
                                        setStartDate('');
                                        setEndDate('');
                                    }}
                                >
                                    Reset
                                </button>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-bordered table-hover mb-0">
                                <thead style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#EF6C00' }}>
                                    <tr style={{ backgroundColor: '#EF6C00', color: '#fff' }}>
                                        <th className="text-center text-white">วันที่ใบสำคัญจ่าย</th>
                                        <th className="text-center text-white">เลขที่ใบสำคัญจ่าย</th>
                                        <th className="text-center text-white">ผู้ขาย</th>
                                        <th className="text-center text-white">ชื่อสินค้า</th>
                                        <th className="text-center text-white">จำนวน</th>
                                        <th className="text-center text-white">หน่วย</th>
                                        <th className="text-center text-white">ราคาต่อหน่วย</th>
                                        <th className="text-center text-white">ส่วนลด</th>
                                        <th className="text-center text-white">%</th>
                                        <th className="text-center text-white">จำนวนเงินรวม</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paginatedRows && paginatedRows.length > 0 ? (
                                        paginatedRows.map((row, index) => (
                                            <tr key={`${sliceStart + index}-${row.Pay_No || ''}`}>
                                                <td className="text-center">{formatDate(row.Pay_Date)}</td>
                                                <td className="text-center">{row.Pay_No}</td>
                                                <td className="text-left">{row.AP_Name}</td>
                                                <td className="text-left">{row.Item_Name}</td>
                                                <td className="text-end">{row.Item_Qty}</td>
                                                <td className="text-center">{row.Item_Unit}</td>
                                                <td className="text-end">{formatCurrency(row.Item_Price_Unit)}</td>
                                                <td className="text-end">{formatCurrency(row.Item_Discount)}</td>
                                                <td className="text-center">
                                                    {row.Item_DisType === 1 ? '฿' : row.Item_DisType === 2 ? '%' : row.Item_DisType}
                                                </td>
                                                <td className="text-end">{formatCurrency(row.Item_Total)}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="10" className="text-center text-muted">ยังไม่มีข้อมูลแสดง</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 pt-3 border-top mt-2">
                                <div>
                                    <select
                                        value={itemsPerPageDropdown}
                                        onChange={handleItemsPerPageChange}
                                        className="form-select"
                                        style={{ width: 'auto', minWidth: '5rem' }}
                                    >
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={30}>30</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                </div>
                                <div className="text-muted small">
                                    <span>
                                        แสดง {data.length === 0 ? 0 : `${startIndex}-${endIndex}`} จาก{" "}
                                        {data.length.toLocaleString()} รายการ
                                    </span>
                                </div>
                                <Pagination
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    itemsPerPage={itemsPerPageDropdown}
                                    dataMasterList={data}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>ปิด</button>
                    </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewHistoryItem;